<template>
  <div class="login">
    <div class="advertising">
      <h1 class="welcome">欢迎登录德邦月结中心</h1>
      <!-- <div class="welcome">欢迎登录德邦月结中心</div> -->
      <div class="df">
        <div
          class="brief-Introduction-contentt"
          v-for="(item, key) in functionalDescription"
          :key="key"
        >
          <!-- <img class="grounding-icon" :src=item.icon alt="" /> -->
          <img v-if="item.icon==1" class="grounding-icon" src="../../assets/picture/login-bgc-1.png" alt="">
          <img v-if="item.icon==2" class="grounding-icon" src="../../assets/picture/login-bgc-2.png" alt="">
          <img v-if="item.icon==3" class="grounding-icon" src="../../assets/picture/login-bgc-3.png" alt="">
          <div class="functional-description">{{ item.name }}</div>
        </div>
        <!-- <div class="brief-Introduction-contentt">
      </div>
      <div class="brief-Introduction-contentt">
      </div> -->
      </div>
    </div>
    <div class="tip">
      <!-- 未查到客户编码 1-->
      <div class="Not-a-monthly-statement" v-if="ISshow == 1">
        <img src="../../assets/picture/Not-a-monthly-statement.png" alt="" />
        <div class="hint">末查询到您的合同，请核实您是否已签订月结合同。</div>
        <!-- <div></div> -->
        <div class="mr">
          <div>
            <el-button
              type="primary"
              style="width: 272px; background: #008cff"
              @click="alternativeEvents(2)"
              >成为月结</el-button
            >
          </div>
          <div>
            <span class="btn text-no" @click="alternativeEvents(3)"
              >我是月结</span
            >
          </div>
        </div>
      </div>
      <!-- 线索录入 2-->
      <div v-if="ISshow == 2">
        <signboard signboardName="月结申请"></signboard>
        <div class="from">
          <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="客户名称：" required>
              <el-input
                size="small"
                placeholder="怎么称呼您…"
                v-model="form.name"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" required>
              <el-input
                size="small"
                placeholder="怎么联系您…"
                v-model="form.phoneNum"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="所属行业：" required>
              <el-select
                size="small"
                v-model="form.industryList"
                placeholder="请选择"
                @change="TimeRangeSearch1"
              >
                <el-option
                  v-for="(item,index) in industryList"
                  :key="item.id"
                  :label="item.tradeName"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="每月发货费用：" required>
              <el-select
                size="small"
                v-model="form.logisticsCostLists"
                placeholder="请选择"
                @change="TimeRangeSearch2"
              >
                <el-option
                  v-for="(item,index) in logisticsCostList"
                  :key="item.id"
                  :label="item.codeDesc"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="arealist" label="所在地区：" required>
              <div
                class="select-address text-hidden pointer"
                @click="areaFocus"
              >
                {{ form.region }}
              </div>
              <van-area
                v-show="areaShow"
                title="选择省市区"
                :area-list="areaList"
                @cancel="areaCancel"
                @confirm="areaConfirm"
                :visible-item-count="5"
              />
            </el-form-item>
            <el-form-item label="" required>
              <el-input
                v-model="form.address"
                placeholder="请输入详细地址"
                size="small"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="mr">
            <el-checkbox class="text2" v-model="radio"
              >我已阅读并同意 <span @click="go">《资讯服务》</span></el-checkbox
            >
            <!-- <el-radio class="text2" v-model="radio" label="1"
              >我已阅读并同意</el-radio
            > -->
            <div>
              <el-button
                type="primary"
                style="width: 272px; background: #008cff"
                :loading="submitInformation"
                @click="alternativeEvents(4)"
                >提交信息</el-button
              >
            </div>
            <div>
              <span class="btn text-no" @click="alternativeEvents(3)"
                >我是月结</span
              >
            </div>
          </div>
        </div>
      </div>
      <!-- 未查到有效合同 3-->
      <!-- 您的客户编码：9847492 未查询到有效合同，如有确实已签订合同，请联系  -->
      <div class="Not-a-monthly-statement" v-if="ISshow == 3">
        <span class="TitBtn" @click="ISshow = 1"
          ><i class="el-icon-arrow-left"></i> 返回</span
        >
        <img
          class="imgs"
          src="../../assets/picture/Not-a-monthly-statement.png"
          alt=""
        />
        <!-- <div class="hints">{{noContract}}</div> -->
        <!-- 您的客户编码：9847492 未查询到有效合同，如有确实已签订合同，请联系  -->
        <div class="hints" v-if="aaaa">
          <span v-if="entity.customerCode"
            >您的客户编码：{{ entity.customerCode }}</span
          >
          未查询到有效合同，如有确实已签订合同，请联系
          <span v-if="entity.monthLeaderInfo.empName" class="weight"
            >姓名：{{ entity.monthLeaderInfo.empName }}，</span
          >
          <span class="weight" v-if="entity.monthLeaderInfo.phone"
            >电话：{{ entity.monthLeaderInfo.phone }}</span
          >
          <span v-else class="weight">95353</span>
          ,或者你的
          <span class="weight">发货网点</span>
        </div>
        <div class="hints" v-else>
          未查询到有效合同，如有确实已签订合同，请联系
          <span class="weight">95353</span>
          ,或者你的
          <span class="weight">发货网点</span>
        </div>
        <div class="mr">
          <div>
            <el-button
              type="primary"
              style="width: 272px; background: #008cff"
              @click="alternativeEvents(2)"
              >成为月结</el-button
            >
          </div>
        </div>
      </div>
      <!-- 线索录入成功  4 -->
      <!-- <div class="Not-a-monthly-statement" v-if="ISshow == 4">
        <signboard signboardName="月结申请"></signboard>
        <img class="img4" src="../../assets/picture/await.png" alt="">
        <div class="hints" style="margin: 0 10px 75px 34px;">
          <div>提交成功~</div>
          <div>稍后会有专属客服联系您</div>
        </div>
        <div class="mr">
          <div>
            <el-button type="primary" style="width: 272px;background: #008CFF;" @click="alternativeEvents(2)">重新提交信息申请</el-button>
          </div>
          <div>
            <span class="btn text-no" @click="alternativeEvents(3)">我是月结</span>
          </div>
        </div>
      </div> -->
      <!-- 线索录入成功或有线索录入 -->
      <div class="Not-a-monthly-statement" v-if="ISshow == 4">
        <signboard signboardName="月结申请已提交"></signboard>
        <img class="img4" src="../../assets/picture/await.png" alt="" />
        <div class="hints" style="margin: 0 10px 48px 34px">
          <div>提交成功~</div>
          <div>稍后会有专属客服联系您</div>
        </div>
        <div class="information">
          <div><span>客户名称：</span> {{informations.customerName}}</div>
          <div><span>联系方式：</span> {{informations.telephone}}</div>
          <div><span>所属行业：</span> {{informations.industry}}</div>
          <div><span>月发货量：</span> {{informations.logisticsCost}}</div>
          <div><span>详细地址：</span> {{informations.address}}</div>
        </div>
      </div>
      <a class="loginOut2" href="https://www.deppon.com">返回官网</a>
    </div>
  </div>
</template>

<script>
import signboard from "@/components/signboard";
import { areaList } from "@vant/area-data";
import API from "@/api/login";
const api = new API();
export default {
  components: { signboard },
  data() {
    return {
      aaaa:true,
      informations:{},
      submitInformation:false,
      entity: {},
      radio: false,
      ISshow: 1,
      ISshows: 1,
      areaShow: false, // 省市区 显隐
      areaList,
      logisticsCostListObject:'',
      industryListObject:'',
      logisticsCostList: [],
      industryList: [],
      functionalDescription:[
        {
          name: "随时查看月结账单",
          icon: "1",
        },
        {
          name: "发货明细实时查询",
          icon: "2",
        },
        {
          name: "月结账号自主管理",
          icon: "3",
        },
      ],
      form: {
        phoneNum: "",
        industryList: "",
        logisticsCostLists: "",
        name: "",
        region: "省/市/区",
        address: "",
      },
    };
  },
  methods: {
    TimeRangeSearch1(value) {
      this.industryListObject = value
      
    },
    TimeRangeSearch2(value) {
      this.logisticsCostListObject = value
    },
    async getCustomerApplyInfoEnum(e) {
      let res = await api.getCustomerApplyInfoEnum();
      this.ISshow = e;
      this.logisticsCostList = res.logisticsCostList;
      this.industryList = res.industryList;
    },
    async queryCrmCustomerByTelephone(e) {
      let res = await api.queryCrmCustomerByTelephone({
        phoneNum: window.localStorage.getItem("phoneNums"),
      });
      this.ISshow = e;
      console.log(JSON.parse(res.entity));
      if (res.entity != "{}") {
        // JSON.parse(res.entity);
        this.entity = JSON.parse(res.entity);
      } else {
        this.ISshow = e;
        this.aaaa = false
      }
    },
    go() {
      const url = window.location
      window.open(url.origin+url.pathname +"#/login/consultationService");
    },
    alternativeEvents(e) {
      // this.ISshow = e;
      if (e == 2) {
        this.getCustomerApplyInfoEnum(e);
      } else if (e == 3) {
        this.queryCrmCustomerByTelephone(e);
      } else if (e == 4) {
        if( this.form.industryList === '' || this.form.logisticsCostLists === '' || this.form.name == '' || this.form.region == '省/市/区' ||  this.form.address == ''){
          return this.$message({
            message: '请填写完整信息',
            type: 'error',
            offset: 300,
          });
        }
        if(!this.radio){
          return this.$message({
            message: '请勾选并阅读资讯服务',
            type: 'error',
            offset: 300,
          });          
        }
        this.submitInformation = true
        window.setTimeout(() => {
          this.submitInformation = false;
        }, 7000);
        this.saveCustomerApplyInfo(e);
      }
    },
    // 线索录入提交信息
    async saveCustomerApplyInfo(e) {
      let params = {
        consultationService: "1.0", //资讯服务
        phoneNum: window.localStorage.getItem("phoneNums"),
        customerName: this.form.name,
        address: this.form.region + "/" + this.form.address,
        industry: this.industryList[this.industryListObject],
        logisticsCost: this.logisticsCostList[this.logisticsCostListObject],
      };
      let res = await api.saveCustomerApplyInfo(params);
      if(res.result){
        this.ISshow = e;
        this.submitInformation = false;
        this.getCustomerApplyInfo()
      }else{
        this.submitInformation = false;
        this.$message({
          message: res.failedReason,
          type: 'error'
        });
      }
      
    },
    //查询是否有提交过线索录入
    async getCustomerApplyInfo() {
      let res = await api.getCustomerApplyInfo({phoneNum: window.localStorage.getItem("phoneNums"),});
      if(JSON.parse(res.entity)){
         this.ISshow = 4;
         this.informations = JSON.parse(res.entity)
        //  console.log(this.informations,1111111);
        let temporary = this.informations.telephone.substring(0, 3) + "****" + this.informations.telephone.substring(7);
        this.informations.telephone = temporary;
      }
    },
    areaConfirm(v) {
      this.form.region = v[0].name + "/" + v[1].name + "/" + v[2].name;
      this.areaShow = false;
    },
    areaCancel() {
      this.areaShow = false;
    },
    areaFocus() {
      this.areaShow = true;
    },
  },
  created() {
    if(window.location.href.split("phoneNum=")[1]){
      // 发送请求时用到手机号
      window.localStorage.setItem("phoneNums", window.location.href.split("phoneNum=")[1]);
      // 页面显示脱敏的手机号
      let temporary = window.localStorage.getItem("phoneNums").substring(0, 3) + "****" + window.localStorage.getItem("phoneNums").substring(7);
      this.form.phoneNum = temporary;
       window.localStorage.setItem("phoneNum", temporary);
      const url = window.location
      location.href=url.origin+url.pathname +"#/login";
    }else{
      if(window.localStorage.getItem("phoneNums")){
      this.form.phoneNum = window.localStorage.getItem("phoneNum");
      }else{
        window.location.href = "https://www.deppon.com"
      }
    }
    this.getCustomerApplyInfo()
  },
};
</script>

<style lang="less" scoped>
.login {
  flex: 1;
  position: relative;
  overflow: auto;
  background: #f7f7f8;
  .advertising {
    justify-content: flex-end;
    text-align: left;
    margin-top: 150px;
    position: absolute;
    right: 42%;
    .brief-Introduction-contentt {
      width: 177px;
      height: 231px;
      background-image: url("../../assets/picture/login-bgc.png");
      background-size: 100%;
      margin-right: 39px;
      .grounding-icon {
        width: 70px;
        height: 78px;
        margin: 44px 52px 37px 55px;
      }
      .functional-description {
        font-size: 16px;
        font-weight: 400;
        color: #33363a;
        text-align: center;
      }
    }
    .welcome {
      font-size: 26px;
      color: #4288ee;
      letter-spacing: 2px;
      margin-bottom: 24px;
    }
  }
  /deep/.el-checkbox__inner {
    border-radius: 50%;
  }
  .Not-a-monthly-statement {
    position: relative;
    .TitBtn {
      display: inline-block;
      text-align: center;
      width: 76px;
      height: 32px;
      line-height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #afb1b7;
      padding-right: 10px;
      color: rgba(0, 0, 0, 0.6);
      cursor: pointer;
      margin-right: 20px;
      position: absolute;
      top: 24px;
      left: 24px;
    }
    .weight {
      color: #000;
      font-weight: 500;
    }
    img {
      width: 230px;
      margin: 105px 0 16px 24px;
    }
    .imgs {
      width: 230px;
      margin: 151px 0 16px 24px;
    }
    .img4 {
      width: 230px;
      margin: 32px 0 16px 24px;
    }
    .hint {
      margin: 0 71px 48px 71px;
      width: 272px;
      height: 48px;
      font-size: 18px;
      color: #212d3e;
      line-height: 24px;
    }
    .hints {
      margin: 0 10px 59px 34px;
      height: 48px;
      font-size: 18px;
      color: #212d3e;
      line-height: 24px;
    }
  }
  .select-address {
    width: 260px;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    text-align: left;
    padding: 0 15px;
    line-height: 32px;
    font-size: 13px;
  }
  .tip {
    width: 414px;
    height: 574px;
    padding-right: 24px;
    position: absolute;
    right: 10%;
    top: 5%;
    background: #ffffff;
    box-shadow: 10px 20px 40px 0px rgba(76, 158, 230, 0.06),
      0px 0px 9px 0px rgba(7, 69, 123, 0.06);
    border-radius: 8px;
    /deep/.signboard {
      .span {
        margin-left: 0;
      }
    }
    /deep/.el-form-item {
      text-align: left;
      padding-left: 10px;
      margin-bottom: 18px;
      .el-form-item__label {
        position: relative;
        width: 120px !important;
      }
      .el-form-item__content {
        margin-left: 120px !important;
      }
    }
    /deep/.el-form-item {
      text-align: right;
      .el-input__inner {
        width: 260px;
      }
      .el-form-item__label {
        padding: 0;
      }
    }
    .mr {
      margin-left: 30px;
    }
    /deep/.el-form {
      .arealist {
        margin-bottom: 0px;
        .el-form-item__content {
          position: relative;
          .van-area {
            position: absolute;
            bottom: 48px;
            left: -50%;
            background-color: #fff;
            z-index: 111111;
            width: 150%;
            box-shadow: 0px 0px 18px #cbcbcbd1;
            border-radius: 5px;
          }
        }
      }
    }
    .text2 {
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      margin-top: 12px;
      margin-bottom: 22px;
    }
    .btn {
      display: inline-block;
      margin: 20px;
      color: #008cff;
      cursor: pointer;
      &:hover {
        color: #008cff99;
      }
    }
    .loginOut2 {
      color: #008cff;
      text-align: right;
      position: absolute;
      bottom: 24px;
      right: 24px;
    }
  }
  .information {
    font-size: 14px;
    font-weight: 600;
    color: #323233;
    text-align: left;
    margin: 24px;
    div {
      padding-bottom: 16px;
      span {
        font-weight: 400;
        color: #323233;
      }
    }
  }
}
</style>